__turbopack_context__.v({
  "ctaBand": "seasonal-module__GjTZ5a__ctaBand",
  "ctaBandSlim": "seasonal-module__GjTZ5a__ctaBandSlim",
  "ctaHeadline": "seasonal-module__GjTZ5a__ctaHeadline",
  "ctaSubtitle": "seasonal-module__GjTZ5a__ctaSubtitle",
  "editorialList": "seasonal-module__GjTZ5a__editorialList",
  "editorialListItem": "seasonal-module__GjTZ5a__editorialListItem",
  "hairline": "seasonal-module__GjTZ5a__hairline",
  "hero": "seasonal-module__GjTZ5a__hero",
  "heroKicker": "seasonal-module__GjTZ5a__heroKicker",
  "heroStat": "seasonal-module__GjTZ5a__heroStat",
  "heroStatLabel": "seasonal-module__GjTZ5a__heroStatLabel",
  "heroStatValue": "seasonal-module__GjTZ5a__heroStatValue",
  "heroStats": "seasonal-module__GjTZ5a__heroStats",
  "heroTagline": "seasonal-module__GjTZ5a__heroTagline",
  "heroTitle": "seasonal-module__GjTZ5a__heroTitle",
  "kicker": "seasonal-module__GjTZ5a__kicker",
  "lede": "seasonal-module__GjTZ5a__lede",
  "numberFigure": "seasonal-module__GjTZ5a__numberFigure",
  "numberedItem": "seasonal-module__GjTZ5a__numberedItem",
  "numberedItemText": "seasonal-module__GjTZ5a__numberedItemText",
  "numberedList": "seasonal-module__GjTZ5a__numberedList",
  "seasonBlock": "seasonal-module__GjTZ5a__seasonBlock",
  "seasonName": "seasonal-module__GjTZ5a__seasonName",
  "seasonTemperament": "seasonal-module__GjTZ5a__seasonTemperament",
  "sectionTitle": "seasonal-module__GjTZ5a__sectionTitle",
  "serif": "seasonal-module__GjTZ5a__serif",
  "subseasonDesc": "seasonal-module__GjTZ5a__subseasonDesc",
  "subseasonMeta": "seasonal-module__GjTZ5a__subseasonMeta",
  "subseasonName": "seasonal-module__GjTZ5a__subseasonName",
  "subseasonRow": "seasonal-module__GjTZ5a__subseasonRow",
  "swatch": "seasonal-module__GjTZ5a__swatch",
  "swatchStrip": "seasonal-module__GjTZ5a__swatchStrip",
});
